import React from "react";
import "./style.scss";

interface CheckboxProps {
    name: string;
    value: string;
    disabled?: boolean;
    checked: boolean;
    label: string | React.ReactNode;
    onChange: (val: boolean) => void;
}

const Checkbox = (props: CheckboxProps) => {
    return (
        <div className="vapor_checkbox-container">
            <div
                className={`vapor_checkbox-wrapper ${props.disabled ? "disabled" : ""}`}
            >
                <input
                    disabled={props.disabled}
                    onChange={(e) => props.onChange(e.target.checked)}
                    className="vapor_checkbox-checkbox"
                    type="checkbox"
                    id={props.name}
                    name={props.name}
                    key={props.name}
                    value={props.value}
                    checked={props.checked}
                />
                <label className="vapor_checkbox-label" htmlFor={props.name}>
                    {props.label}
                </label>
            </div>
        </div>
    );
};

Checkbox.defaultProps = {
    checked: false,
    disabled: false,
};

export default Checkbox;
